<script>
import { loadGoogleMaps } from './googleMapsLoader'

export default {
  name: 'GmapMarker',
  inject: {
    gmapContext: {
      default: null
    }
  },
  props: {
    position: {
      type: Object,
      required: true
    },
    draggable: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      marker: null,
      markerListeners: []
    }
  },
  watch: {
    position: {
      deep: true,
      handler (value) {
        if (!this.marker || !value) return
        this.marker.setPosition(value)
      }
    },
    draggable (value) {
      if (!this.marker) return
      this.marker.setDraggable(value)
    },
    clickable (value) {
      if (!this.marker) return
      this.marker.setClickable(value)
    }
  },
  async mounted () {
    const mapPromise = this.gmapContext?.getMapPromise?.()
    if (!mapPromise) {
      return
    }

    const google = await loadGoogleMaps()
    const map = await mapPromise

    this.marker = new google.maps.Marker({
      map,
      position: this.position,
      draggable: this.draggable,
      clickable: this.clickable
    })

    this.markerListeners.push(
      this.marker.addListener('dragend', (event) => {
        this.$emit('dragend', event)
      })
    )
  },
  beforeUnmount () {
    this.markerListeners.forEach((listener) => listener.remove())
    this.markerListeners = []

    if (this.marker) {
      this.marker.setMap(null)
    }
  },
  render () {
    return null
  }
}
</script>
